import { useSelector } from 'react-redux'
import { selectCustomerById } from 'selectors/customers'
import SampleCustomerRow from './SampleCustomerRow'

interface SampleCustomerRowWrapperProps {
  customerId: string
  index: number
  isLast: boolean
}

const SampleCustomerRowWrapper = ({
  customerId,
  index,
  isLast,
}: SampleCustomerRowWrapperProps) => {
  const customer = useSelector(selectCustomerById(customerId))

  if (!customer) return null

  return <SampleCustomerRow customer={customer} index={index} isLast={isLast} />
}

export default SampleCustomerRowWrapper
